import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'vc-legal-warranties-modal',
  templateUrl: './legal-warranties-modal.component.html',
  styleUrls: ['./legal-warranties-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalWarrantiesModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
